import BulkOperationsController from './BulkOperationsController'

export default class BulkDeleteTasksController extends BulkOperationsController {
    constructor({
        onSuccess = () => {},
        onProgress = () => {},
        onFailure = () => {},
    }) {
        super({
            method: 'TaskManagementService.deleteTasks',
            initialResult: {
                deletedTaskIds: [],
                notAvailableTaskIds: [],
                successTaskIds: [],
            },
            combineFn: (result, chunkResult) => {
                return {
                    deletedTaskIds: [...result.deletedTaskIds, ...chunkResult.deletedTaskIds],
                    notAvailableTaskIds: [...result.notAvailableTaskIds, ...chunkResult.notAvailableTaskIds],
                    successTaskIds: [...result.successTaskIds, ...chunkResult.successTaskIds],
                }
            },
            onSuccess,
            onProgress,
            onFailure,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/controller/BulkDeleteTasksController.js